import React from 'react';
import { translate, Trans } from 'react-i18next';

import { Link } from 'react-router-dom';
import { Checkbox, Button, Form, Input, Grid, Header, Message, Label, Segment, Responsive } from 'semantic-ui-react';

import ForgotPasswordContainer from './ForgotPasswordContainer';

import { colors, fontSizes } from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
    column: {
        maxWidth: '400px'
    },
    createAct: {
        display: 'inline',
        color: colors.themeDarkerGrey,
        fontSize: fontSizes.bodyL,
        lineHeight: fontSizes.h4,
        // fontStyle: 'italic',
    },
    forgot: {
        cursor: 'pointer',
        textAlign: 'left',
    },
};

const LogIn = ({ t,
    valid,
    email,
    password,
    publicComputer,
    onSubmit,
    onEmailChange,
    onPasswordChange,
    onSetPublicComputer,
    emailError,
    passwordError,
    error,
    showForgotPassword,
    onShowForgotPassword,
    onCloseForgotPassword }) => (
        <Form style={style.form} noValidate onSubmit={onSubmit}>
            <Grid style={style.content}>
                <Grid.Row style={style.row} verticalAlign='top'>
                    <Grid.Column style={style.bannerColumn} verticalAlign='top'>
                        <div style={style.banner}>
                            <div style={style.welcome}>{t('Log In')}</div>
                            <br />
                            <div style={style.createAct}>{t('to your Optimity account')}</div>
                        </div>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column style={style.column} verticalAlign='middle'>
                        <div style={style.inputLabel}>{t('Email Address')}</div>
                        <Form.Field style={style.field}>
                            <input
                                style={{
                                    ...style.input,
                                    ...(emailError.length ? style.inputError : {})
                                }}
                                type="text"
                                name="userEmail"
                                value={email}
                                onChange={onEmailChange}
                                required
                            />
                            {emailError.length > 0 &&
                                <Label basic color="red" pointing style={style.errorLabelBottom}>{emailError}</Label>
                            }
                        </Form.Field>
                        <div style={style.inputLabel}>{t('Password')}</div>
                        <Form.Field style={style.field}>
                            <input
                                style={{
                                    ...style.input,
                                    ...(passwordError.length ? style.inputError : {})
                                }}
                                type="password"
                                name="userPassword"
                                value={password}
                                onChange={onPasswordChange}
                                required
                            />
                            {passwordError.length > 0 &&
                                <Label basic color="red" pointing style={style.errorLabelBottom}>{passwordError}</Label>
                            }
                        </Form.Field>
                        <Form.Field style={style.fieldCheckbox}>
                            <Checkbox style={style.checkbox} 
                                onChange={onSetPublicComputer}
                                name={'publicComputer'} 
                                value={publicComputer}/>{t('Public Computer')}
                        </Form.Field>
                        <div style={{ ...style.forgot, ...style.anchor }} onClick={onShowForgotPassword}>{t('Forgot Password?')}</div>
                        {error.length > 0 &&
                            <Message negative>{error}</Message>
                        }
                        <br />
                        <br />
                        <br />
                        <Button style={valid ? style.blueButton : style.greyButton} type="submit">{t('Log In')}</Button>
                        {showForgotPassword &&
                            <ForgotPasswordContainer onClose={onCloseForgotPassword} />
                        }
                        <Responsive {...Responsive.onlyMobile}>
                            <Grid.Row style={style.topRow}>
                                <Grid.Column style={style.topLink} verticalAlign="top" textAlign='right'>
                                    <Trans i18nKey="new_here">
                                        New here? <Link to='/register' style={style.anchor}>Sign Up</Link>
                                    </Trans>
                                </Grid.Column>
                            </Grid.Row>
                        </Responsive>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column style={style.column} verticalAlign='bottom'>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Form>
    );

export default translate('authentication')(LogIn);



// WEBPACK FOOTER //
// ./src/modules/authentication/LogIn.js